module.exports = __webpack_public_path__ + "static/img/logo.7df3dc6f.png";